export default {
  debounce: (callback, wait, immediate = false) => {
    let timeout = null

    return function () {
      const callNow = immediate && !timeout
      const next = () => callback.apply(this, arguments)

      clearTimeout(timeout)
      timeout = setTimeout(next, wait)
      if (callNow) {
        next()
      }
    }
  },

  compareObjects: (object, target) => {
    for (const p in object) {
      if (Object.prototype.hasOwnProperty.call(target, p)) {
        if (object[p] !== target[p]) {
          return false
        }
      }
    }
    return true
  }
}
